import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Approach from '../components/Approach';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const Landing = () => {
  return (
    <main className="bg-cream sans-body text-ink">
      <Header />
      <Hero />
      <Services />
      <Approach />
      <ContactSection />
      <Footer />
    </main>
  );
};

export default Landing;
